<template>
    <button v-ripple="!disabled && !answer.disabled" type="button" :class="classList" @click="onClick" @keyup="onKeyup">
        <v-checkbox
            v-if="!hideCheckbox"
            class="app-question-answer__checkbox"
            :value="answer.value"
            :input-value="answer.value"
            hide-details
            dense
            :ripple="false"
            :disabled="disabled || answer.disabled"
            :color="answer.value ? 'background' : 'primaryText'"
            readonly
            :tabindex="-1"
            :off-icon="offIcon"
            :on-icon="onIcon"
        />
        <display-content class="app-question-answer__text" :value="answer.text" />
    </button>
</template>

<script>
import { AppQuestionAnswer } from '@/models';

export default {
    name: 'AppQuestionAnswer',
    props: {
        answer: {
            type: AppQuestionAnswer,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        hideCheckbox: {
            type: Boolean,
            default: false
        },
        boxStyle: {
            type: String,
            default: 'checkbox' // checkbox, radio
        }
    },
    computed: {
        classList() {
            let classList = ['app-question-answer'];

            if (this.disabled || this.answer.disabled) {
                classList.push('app-question-answer--disabled');
            }

            if (!this.hideCheckbox) {
                classList.push('app-question-answer--checkbox');
            }

            if (this.answer.value) {
                classList.push('app-question-answer--selected');
            }

            return classList;
        },
        offIcon() {
            return this.getIcon(`${this.boxStyle}Off`);
        },
        onIcon() {
            return this.getIcon(`${this.boxStyle}On`);
        }
    },
    methods: {
        onClick() {
            if (this.disabled || this.answer.disabled) {
                return;
            }
            this.$emit('answer:selected', this.answer, !this.answer.value);
        },
        onKeyup(event) {
            if (event.keyCode === 13) {
                this.onClick();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.app-question-answer {
    position: relative;
    display: block;
    padding: 0.5rem 1rem;
    color: rgba(0, 0, 0, 0.87);
    border: 2px solid var(--v-background-darken2);
    background: var(--v-background-darken2);
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    transition: all 0.15s ease-in-out;
    text-align: left;
    &:not(:last-child) {
        margin-bottom: 0.5rem;
    }
    &:hover {
        border-color: var(--v-background-darken4);
        background: var(--v-background-darken4);
    }
    &:focus {
        border-color: var(--v-background-darken4);
    }
    &--disabled {
        opacity: 0.5;
        cursor: default;
        &:hover {
            color: rgba(0, 0, 0, 0.87);
            border-color: var(--v-background-darken2);
            background: var(--v-background-darken2);
        }
    }
    &--selected {
        color: var(--v-background-base);
        border-color: var(--v-primaryText-base) !important;
        background: var(--v-primaryText-base);
        &:hover {
            color: var(--v-background-base);
            border-color: var(--v-primaryText-base) !important;
            background: var(--v-primaryText-base);
        }
    }
    &--checkbox {
        padding-left: 2.4rem;
    }
    &__checkbox {
        position: absolute;
        top: 0;
        left: 0;
        margin-top: 0.45rem !important;
        margin-left: 0.5rem;
    }
}
</style>
